import React from "react";
import { useParams, Redirect } from "react-router-dom";
import { useAppUserAuthSelector } from "src/_common/hooks/selectors/userSelector";
import ResetPasswordModal from "src/components/common/Modal/auth/ResetPasswordModal";
import { useHistory } from "react-router-dom";

const ResetPasswordContainer: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const isAuthenticated = useAppUserAuthSelector();
  const history = useHistory();

  // If already logged in, redirect to root landing page
  if (isAuthenticated) {
    return <Redirect to="/" />;
  }

  const handleClose = () => {
    history.push("/");
  };

  const handleResetSuccess = () => {
    history.push("/");
  };

  return (
    <ResetPasswordModal
      isOpen={true}
      onClose={handleClose}
      onResetSuccess={handleResetSuccess}
      token={token}
    />
  );
};

export default ResetPasswordContainer;
